import React from 'react';
import styled from 'styled-components';
import nanawallLogo from '../assets/images/manuf_logos/nanawall_logo.svg';
import eswindowsLogo from '../assets/images/manuf_logos/eswindows_logo.svg';
import windoorLogo from '../assets/images/manuf_logos/windoor_logo.svg';
import eurowallLogo from '../assets/images/manuf_logos/eurowall_logo.svg';
import cgiWindowsLogo from '../assets/images/manuf_logos/cgi_windows_logo.svg';
import pgtLogo from '../assets/images/manuf_logos/pgt_logo.svg';
import velocityImpactLogo from '../assets/images/manuf_logos/velocity_impact_logo.svg';
import aldoraLogo from '../assets/images/manuf_logos/aldora_logo.svg';

const BannerContainer = styled.div`
  width: 100%;
  padding: 2rem 0;
  text-align: center;
  background-color: #fefefe;
`;

const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;

  &::before,
  &::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #2e2e2e;
    margin: 0 1rem;
  }
`;

const TitleText = styled.h2`
  font-size: 1.5rem;
  color: #2e2e2e;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
`;

const LogoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const Logo = styled.img`
  max-width: 100%;
  height: auto;
  max-height: 80px;
  object-fit: contain;
`;

const logos = [
  { src: nanawallLogo, alt: 'NanaWall' },
  { src: eswindowsLogo, alt: 'ES Windows' },
  { src: windoorLogo, alt: 'Windoor' },
  { src: eurowallLogo, alt: 'EuroWall' },
  { src: cgiWindowsLogo, alt: 'CGI Windows' },
  { src: pgtLogo, alt: 'PGT' },
  { src: velocityImpactLogo, alt: 'Velocity Impact' },
  { src: aldoraLogo, alt: 'Aldora' },
];

function LogoBanner() {
  return (
    <BannerContainer>
      <SectionTitle>
        <TitleText>We Only Use The Best</TitleText>
      </SectionTitle>
      <LogoGrid>
        {logos.map((logo, index) => (
          <LogoContainer key={index}>
            <Logo src={logo.src} alt={logo.alt} />
          </LogoContainer>
        ))}
      </LogoGrid>
    </BannerContainer>
  );
}

export default LogoBanner;